import React, { useState, useEffect, useCallback, useRef } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions, Grid, Typography,
    TextField, Button, Select, MenuItem, Divider, Box, Snackbar, Alert, Switch, 
} from '@mui/material';
import colors from "assets/mavric-theme/base/colors.js";
import typography from "assets/mavric-theme/base/typography";
import borders from "assets/mavric-theme/base/borders";
import { editAdminPortalUser } from 'apis/CustomersApis';
const { borderRadius } = borders;
const { primary, secondary, text, transparent, white } = colors;
const { size } = typography;



const EditUserDialog = ({ openDialog, handleUpdateCloseDialog, userRoleList, selectedRow, getAllUserData }) => {
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
    // const [enableSaveBtn, setEnableSaveBtn] = useState(false);
    const initialUserInfo = { user_id: 0, role_id: 0, email: "", first_name: "", last_name: "" };
    const [userInfo, setUserInfo] = useState(initialUserInfo);
    const [usrFName, setUsrFName] = useState('');
    const [usrLName, setUsrLName] = useState('');
    const [role, setRole] = useState('');
    const [error, setError] = useState(null);
    const [alertState, setAlertState] = useState({ open: false, message: '', severity: 'success', vertical: 'bottom', horizontal: 'left' });
    const { vertical, horizontal } = alertState;
    const showAlert = (message, severity = 'success') => {
        setAlertState(prev => ({ ...prev, open: true, message, severity }));
    };
    const [viewAllDemoAccounts, setViewAllDemoAccounts] = useState(false);
    const [demoAccountsModified, setDemoAccountsModified] = useState(false);
    // const prevRoleRef = useRef(selectedRow && selectedRow.role || "");

    useEffect(() => {
        // console.log("selected row,", selectedRow);
        if (selectedRow) {
            setUsrFName(selectedRow.first_name || '');
            setUsrLName(selectedRow.last_name || '');
            setRole(selectedRow.role.toLowerCase() || '');
            // setViewAllDemoAccounts(selectedRow.view_all_demo_accounts || false)
        } else {
            setUsrFName('');
            setUsrLName('');
            setRole('');
            setError('');
            // setViewAllDemoAccounts(false);
            // setDemoAccountsModified(false);
        }
    }, [selectedRow]);


    useEffect(() => {
        // If role changes FROM "salesoperator" TO something else
        // if (role === "salesoperator" || prevRoleRef.current === "salesoperator"){}
    
        if (role === "salesoperator") {
            setViewAllDemoAccounts(!!selectedRow.view_all_demo_accounts);
            setDemoAccountsModified(true);
        } else {
            setViewAllDemoAccounts(false);
            setDemoAccountsModified(false);
        }
        // prevRoleRef.current = role; 
    }, [role]);


    const validateForm = () => {
        const isValid = usrFName.trim() !== '' && role !== '';
        // setEnableSaveBtn(isValid);
        if (!usrFName || !usrFName.trim()) {
            setError("First name is required");
            return false;
        }
        return isValid;
    };

    const resetForm = () => {
        setUsrFName('');
        setUsrLName('');
        setRole('');
        setViewAllDemoAccounts(false);
        setDemoAccountsModified(false);
    };


    const handleTxtFldChange = (e) => {
        const { name, value } = e.target;
        if (name === 'usrFName') {
            setUsrFName(value);
        } else if (name === 'usrLName') {
            setUsrLName(value);
        }
        validateForm();
    };

    const handleCloseDialog = () => {
        resetForm();
        setTimeout(() => handleUpdateCloseDialog(), 0);
    }
 
    const handleUpdateOpenConfirmation = () => {
        if (validateForm()) {
            setOpenConfirmationDialog(true);
        } else {
            setError("First name is required");
        }
    };

    const handleUpdateCloseConfirmation = () => {
        setOpenConfirmationDialog(false);
        // resetForm();
    };

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setAlertState({ ...alertState, open: false });
    }

    const handleSave = async () => {
        if (!validateForm()) return;

        try {
            const updatedUser = {
                first_name: usrFName,
                last_name: usrLName,
                role: role
            };

            if (role === "salesoperator" || demoAccountsModified) {
                updatedUser.enable_view_all_demo_accounts = viewAllDemoAccounts;
                updatedUser.set_view_all_demo_accounts_flag = true;
            }

            await editAdminPortalUser(selectedRow.user_id, updatedUser).then(() => {
                showAlert('User updated successfully', 'success');
            })
            await getAllUserData();
            // console.log("updated user data;", updatedUser);
            handleUpdateCloseConfirmation();
            handleUpdateCloseDialog();
        } catch (error) {
            showAlert('User updation failed', 'error');
            console.error('Update failed:', error);
            // Show error message
        }
    };


    return (
        <div>
            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Edit User Details'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} direction="row">
                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>First Name*</Typography>
                            <TextField
                                id='txtFldUsrFName'
                                name='usrFName'
                                placeholder='First Name'
                                value={usrFName || ''}
                                // value={selectedRow ? (selectedRow.first_name !== null ? selectedRow.first_name : '') : ''}
                                onChange={handleTxtFldChange}
                                sx={{
                                    width: 220,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}
                            />

                        </Grid>

                        <Grid item xs={12} sm={6} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>Last Name</Typography>
                            <TextField
                                id='txtFldUsrLName'
                                name='usrLName'
                                placeholder='Last Name'
                                value={usrLName || ''}
                                // value={selectedRow ? (selectedRow.last_name !== null ? selectedRow.last_name : '') : ''}
                                onChange={handleTxtFldChange}
                                focused={false}
                                sx={{
                                    width: 220,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                }}
                            />
                        </Grid>

                        <Grid item xs={6} sm={6} md={6} lg={6}>
                            <Typography variant="body2" fontSize={size.sm} justifyContent="center" color={text.main} sx={{ fontWeight: 400, }}>User Email</Typography>
                            <TextField
                                id="txtFldUsrEmail"
                                name="usrEmail"
                                placeholder="Email Address"
                                value={selectedRow ? (selectedRow.email !== null ? selectedRow.email : '') : ''}
                                focused={false}
                                disabled={true}
                                sx={{
                                    width: 220,
                                    color: text.main,
                                    borderColor: primary.focus,
                                    backgroundColor: transparent.main,
                                    borderRadius: borderRadius.md,
                                    '& .Mui-disabled .MuiOutlinedInput-notchedOutline': {
                                        border: 'none'
                                    }
                                }}
                            />
                        </Grid>

                        <Grid item xs={12} sm={4} md={4} lg={4}>
                            <Typography
                                variant="body2"
                                fontSize={size.sm}
                                color={text.main}
                                sx={{ fontWeight: 400, mb: 0 }}
                            >
                                Role Type*
                            </Typography>
                            <Select
                                fullWidth
                                name="usrRole"
                                id="usrRole"
                                value={role || ""}
                                onChange={(e) => setRole(e.target.value)}
                                displayEmpty
                                renderValue={(selected) => {
                                    if (!selected) {
                                        return <em style={{ fontStyle: 'normal', color: '#aaa' }}>Select Role</em>;
                                    }
                                    return selected;
                                }}
                                sx={{
                                    width: 220,
                                    '.MuiSelect-select': {
                                        paddingTop: '8px !important',
                                        paddingBottom: '8px !important',
                                        minHeight: '35px !important',
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontSize: '1em !important'
                                    }
                                }}
                            >
                                {userRoleList.map((role) => (
                                    <MenuItem key={role.id} value={role.role}>
                                        {role.role}
                                    </MenuItem>
                                ))}

                            </Select>
                        </Grid>


                        {(role === "salesoperator") && (
                            <Grid item xs={12} sm={6} md={6} lg={6}>

                                <Grid item >
                                    <Typography
                                        variant="body2"
                                        fontSize={size.sm}
                                        justifyContent="center"
                                        color={text.main}
                                        sx={{ fontWeight: 400, mb: 0 }}>
                                        View All Demo Accounts
                                    </Typography>
                                </Grid>
                                
                                <Switch
                                    checked={viewAllDemoAccounts}
                                    onChange={(e) => {
                                        setViewAllDemoAccounts(e.target.checked);
                                        setDemoAccountsModified(true); 
                                    }}
                                    color="primary"
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </Grid>
                        )}

                    </Grid>
                </DialogContent>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: 'auto', maxWidth: '100%', pr: 2, }}>
                    {(error) && (
                        <Alert variant="filled" severity="error" onClick={() => setError(undefined)} sx={{ py: 0 }}>
                            <Typography fontSize={size.sm} color={white.main} sx={{ fontWeight: 400 }}>{error}</Typography>
                        </Alert>
                    )}
                </Box>
                <DialogActions>
                    <Button onClick={handleUpdateCloseDialog} color="secondary" variant="contained">
                        Cancel
                    </Button>
                    <Button onClick={handleUpdateOpenConfirmation} color="secondary" variant="contained">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>


            <Dialog
                open={openConfirmationDialog}
                onClose={handleUpdateCloseConfirmation}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                sx={{
                    '& .MuiDialog-paper': {
                        backgroundColor: primary.main,
                    }
                }}
            >
                <DialogTitle>
                    <Typography variant="body2" color={secondary.main} sx={{ fontWeight: 600, mb: 2 }} gutterBottom>
                        {'Confirmation'}
                    </Typography>
                </DialogTitle>
                <DialogContent>
                    Are you sure you want to save the changes?
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleUpdateCloseConfirmation} color="secondary" variant="contained">
                        No
                    </Button>
                    <Button onClick={handleSave} color="secondary" variant="contained" >
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar
                open={alertState.open}
                autoHideDuration={5000}
                onClose={handleAlertClose}
                anchorOrigin={{ vertical, horizontal }}
                key={`snackbar-${alertState.message}`}
            >
                <Alert
                    onClose={handleAlertClose}
                    severity={alertState.severity}
                    variant='filled'
                    elevation={6}
                    sx={{
                        '& .MuiAlert-message': { color: 'white.main', fontSize: size.sm },
                        marginBottom: 4
                    }}
                >
                    {alertState.message}
                </Alert>
            </Snackbar>
        </div>
    )
}

export default EditUserDialog
